<template>
  <div>
    <progress
      class="progress myprogress is-primary"
      v-show="percent < 100"
      :value="percent"
      max="100"
      id="loading-bar"
    ></progress>
  </div>
</template>
<script>
export default {
  props: {
    url: String,
    isFullscreen: Boolean,
  },
  watch: {
    isFullscreen: function () {
      this.viewer.resize();
      console.log("fs=" + this.fullscreen);
    },
  },
  mounted() {
    const Viewr = require("../../lib/viewer");
    const dat = require("dat.gui");
    this.viewer = new Viewr(this.$el, {});
    dat.GUI.toggleHide();
    if (this.url) {
      this.viewer.load(this.url, this.updateProgress);
    }
    window.onresize = () => {
      this.viewer.resize();
    };
	this.fullscreen = this.isFullscreen
	console.log("fs mounted=" + this.isFullscreen); 
  },
  destroyed() {
    window.onresize = null;
  },
  data() {
    return {
      viewer: null,
      percent: 0,
	  fullscreen: false
    };
  },
  methods: {
    updateProgress(xhr) {
      this.percent = Math.floor((xhr.loaded / xhr.total) * 100);
      console.log(this.percent + "% loaded");
    },
  },
};
</script>
<style lang="scss" scoped>
div {
  min-height: 100vh;

  width: 100%;
  height: 100%;
}
</style>


